import esia from './esia_banner.jpg';
import esmp from './esmp_banner.jpg';
import resettle from './resettle.jpg';

export default {
  esia,
  esmp,
  resettle,
};
